module.exports = __webpack_public_path__ + "img/icon-excel.d777f826.png";